import Vue from 'vue';
import Vuetify from 'vuetify';
import firebase from 'firebase/app';
import 'firebase/auth';
import App from './App.vue';
import router from './router';
import 'vuetify/dist/vuetify.min.css'
import store from './store'
import VueLodash from 'vue-lodash'

Vue.config.productionTip = false;
Vue.use(Vuetify,{
  theme:{
    //primary: '9ac43a',
    primary: '42b8af',
    secondary: 'f4981c',
    //secondary: 'db1a83',
    accent: '9ac43a'
  }
});
Vue.use(VueLodash);

let app = '';

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app');
  }
});
